import axios from 'axios'
import logging from '@/assets/js/functions/_core/logging';
import store from "@/store";

export default {
  mixins: [logging],

  methods: {
    /**
     * 非同期通信設定（method, url, param）をし、実行する
     *
     * @param method 通信方法（@see src/assets/js/constants/endpoints）
     * @param url
     * @param params パラメータ
     * @returns {Promise<*>}
     */
    async callAxios(method, url, params) {
      store.dispatch('cover/toggleLoadCover');

      axios.defaults.headers.common['Content-Type'] = 'application/json';

      let response = null;
      try {
        if (method === 'POST') {
          response = await axios.post(url, params)
        } else if (method === 'GET') {
          response = await axios.get(url)
        }

        if (!response) throw response;
      } catch (error) {
        store.dispatch('cover/toggleLoadCover');
        this.logger(error, "アクションが失敗しました。", error);
        this.logger(error, "お手数ですが運営にお問い合わせください。", null);
        throw error;
      }

      store.dispatch('cover/toggleLoadCover');
      return response;
    },
  }
}
